export default __webpack_public_path__ + "static/media/Syed Usama Ali.53afca50.pdf";